import { Text } from "components/atoms/text/Text";
import { ButtonWrapper, Row, RowModalInput } from "styles/ModalCommonStyled";
import styled from "styled-components";
import BigButton from "components/atoms/buttons/BigButton";
import { FLEX } from "styles/flex";
import { ReactComponent as ONLINE_GREEN } from "assets/icons/online_green.svg";
import { checkEmpty, handleCopyClipBoard } from "utils/functions";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import { COLORS } from "styles/colors";

type Props = {
  successKeyList: string[];
};

export default function SuccessKey(props: Props): JSX.Element {
  const excelFileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const exportStringArrayToExcel = () => {
    // 1. 유효한 값만 필터링 후 A열만 구성
    const worksheetData = props.successKeyList
      .filter((key) => typeof key === "string" && !checkEmpty(key))
      .map((key) => [key]);

    // 2. 시트 생성
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    worksheet["!ref"] = `A1:A${worksheetData.length}`; // 정확한 범위 설정

    // 3. 워크북 생성
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Generate_Key_List");

    // 4. 저장
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: excelFileType });
    FileSaver.saveAs(blob, "Generate_Key_List.xlsx"); // 확장자 추가도 권장
  };

  return (
    <Wrapper>
      <div className="title">
        <ONLINE_GREEN />
        <Text bold>
          {props.successKeyList.length} Keys Generated Successfully!
        </Text>
      </div>

      <div>
        <div className="key-list-wrapper">
          {props.successKeyList.map((key) => (
            <Text fontSize={18}>{key}</Text>
          ))}
        </div>

        <RowModalInput>
          <BigButton
            label="Download"
            buttonType={"cancel"}
            onClickBtn={() => exportStringArrayToExcel()}
            data-testid="subscription-modal-component-button-export-string-array-to-excel"
          />

          <BigButton
            label="Copy All"
            buttonType={"cancel"}
            onClickBtn={() =>
              handleCopyClipBoard(
                props.successKeyList.join("\n"),
                "Genererated Keys"
              )
            }
            data-testid="subscription-modal-component-button-copy-clip-board"
          />
        </RowModalInput>
      </div>
      <Text fontSize={14} color={COLORS.BUTTONS1}>
        Click Download to save the subscription keys in the .xlsx file to share
        with CP.
      </Text>
      <Text fontSize={14} color={COLORS.BUTTONS1}>
        Click Copy All to copy all Subscription keys to paste on the document
        file.
      </Text>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  padding-top: 20px;

  .title {
    ${FLEX.FlexStartCenter};
    gap: 3px;
    margin-bottom: 10px;
  }

  .key-list-wrapper {
    background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
    padding: 30px;
    max-height: 300px;
    overflow-y: auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 10px;

    > div {
      ${FLEX.FlexCenterCenter}
    }
  }
`;
